import React from 'react';
import ReactDOM from 'react-dom';
import UI from './UI';
import './style.css'

ReactDOM.render(<UI />, document.getElementById('root'));
